import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import NFTCollectionLaunchHero from "./NFTCollectionLaunchHero";
import WhyLaunchNFT from "./WhyLaunchNFT";
import BenefitsOfPartnering from "./BenefitsOfPartnering";
import CustomNFTDesign from "./CustomNFTDesign";
import WhyChoose from "../../Wallet/NFT Wallet/WhyChoose";

function NFTCollectionLaunch() {
  return (
    <div>
      <Header />
      <NFTCollectionLaunchHero />
      <WhyLaunchNFT />
      <BenefitsOfPartnering />
      <CustomNFTDesign />
      <WhyChoose />
      <Footer />
    </div>
  );
}

export default NFTCollectionLaunch;
